









































































import InvoiceCard from '@/components/card/InvoiceCard.vue'
import ListView from '@/components/ListView.vue'
import ChangeStatusPopup from '@/components/popup/btt/ChangeStatus.vue'
import ClientFilterPopup from '@/components/popup/btt/ClientFilter.vue'
import OrderPopup from '@/components/popup/btt/Order.vue'
import Translation from '@/mixins/Translation'
import StatusImg from '@/components/image/StatusImg.vue'
import {Component, Mixins, Prop, Ref, Watch} from 'vue-property-decorator'
import {namespace} from 'vuex-class'
import WorkflowHandler from '@/components/WorkflowHandler.vue'
import DialogDrawer from '@/components/DialogDrawer.vue'
import {Invoice} from '@/store/modules/invoices/types'
import {BizPropertyPayload} from '@/store/modules/gtm/types'

const invoice = namespace('invoices')
const layout = namespace('layout')
const clients = namespace('clients')
const institutions = namespace('institutions')
const gtm = namespace('gtm')

interface Client {
  id: string
  name: string
}

@Component({
  components: {
    WorkflowHandler,
    ChangeStatusPopup,
    ListView,
    ClientFilterPopup,
    OrderPopup,
    InvoiceCard,
    StatusImg,
    DialogDrawer
  },
})
export default class AlreadyTransferTabPanel extends Mixins(Translation) {
  @Prop({default: 0, type: Number}) windowScrollY: number
  @Prop({default: false, type: Boolean}) isActive: boolean
  @Prop({default: false, type: Boolean}) isRequiredReload: boolean
  @Prop({default: '', type: String}) tabName: string

  @invoice.State('transferredInvoices') transferredInvoices: object[]
  @invoice.State('transferredNextOffset') transferredNextOffset: null | number
  @invoice.State('transferredCount') transferredCount: number
  @invoice.Action('getTransferredInvoices') getTransferredInvoices
  @invoice.Action('updateInvoiceStatus') updateInvoiceStatus
  @invoice.Mutation('clearTransferredInvoices') clearTransferredInvoices
  @layout.Mutation('updateError') updateError
  @clients.Action('getClients') getClients
  @clients.State('clients') clients
  @clients.State('nextOffset') clientsNextOffset
  @clients.Mutation('clear') clear
  @institutions.Action('getCertInstitutions') getCertInstitutions
  @institutions.Getter('hometaxStatus') hometaxStatus
  @institutions.Getter('gtmInfo') institutionsGtmInfo
  @gtm.Action('setBizProperty') setBizProperty: (payload: BizPropertyPayload) => void

  @Ref('listView') readonly listView: any

  loading: boolean = true
  changingStatus: boolean = false
  openOrder: boolean = false
  openClientFilter: boolean = false
  selectedOrder: string = 'modifiedAt'
  selectedClient: Client | null = null
  loadingClients: boolean = false
  isError: boolean = false
  openChangeStatus: boolean = false
  selectedInvoiceId: string | null = ''
  selectedInvoiceStatus: string | null = ''
  openDialog: boolean = false
  isFirstActive: boolean = true

  get isAvailableLoadInvoices(): boolean {
    const {hometaxStatus} = this
    return hometaxStatus === 'success' || hometaxStatus === 'expired'
  }

  get filterItemList(): object[] {
    return [
      {
        id: 'order',
        value: this.ts(`order.${this.selectedOrder}`),
        icon: 'arrow-down-sm',
      },
      {
        id: 'client-filter',
        value: this.selectedClient ? this.selectedClient.name : `${this.ts('client')} ${this.ts('entire')}`,
        icon: this.selectedClient ? 'cancel-sm' : 'search',
      },
    ]
  }

  get totalCount(): number {
    return this.transferredCount
  }

  get orderList() {
    const {ts} = this
    return [
      {title: ts('order.modifiedAt'), value: 'modifiedAt'},
      {title: ts('order.newest'), value: 'newest'},
      {title: ts('order.lowAmount'), value: 'lowAmount'},
      {title: ts('order.highAmount'), value: 'highAmount'},
    ]
  }

  get isEmpty(): boolean {
    return this.transferredCount === 0
  }

  get invoiceList() {
    const {transferredInvoices, isEmpty} = this
    if(!isEmpty) {
      return transferredInvoices.map((item) => ({...item}))
    }
    return []
  }

  get emptyStatus() {
    const {selectedClient, hometaxStatus, isEmpty} = this
    if(hometaxStatus === 'pending' || hometaxStatus === 'processing' || hometaxStatus === 'failure' || isEmpty && !selectedClient) return 'empty'
    else if(selectedClient) return 'search'
    return 'kakao'
  }

  get emptyMessage() {
    const {hometaxStatus, ts, isEmpty, selectedClient} = this
    if(hometaxStatus === 'pending' || hometaxStatus === 'failure') return ts('message.none-cert')
    else if(hometaxStatus === 'processing') return ts('message.processing-cert')
    else if(isEmpty && !selectedClient) return ts('message.empty-completed')
    else if(selectedClient) return ts('message.empty-search-invoices')
    return ''
  }

  @Watch('selectedOrder')
  __selectedOrder() {
    this.reLoadInvoices()
  }

  @Watch('selectedClient')
  __selectedClient() {
    this.reLoadInvoices()
  }

  @Watch('isActive',{immediate: true})
  __isActive(value) {
    if(value) {
      if(this.isFirstActive) {
        this.initData()
      } else if(this.isRequiredReload) {
        this.reLoadInvoices()
      }
    }
  }

  async initData() {
    this.isError = false
    await this.getCertInstitutions()
    this.clearTransferredInvoices()
    if(this.isAvailableLoadInvoices) {
      this.loadInvoices()
    } else {
      this.loading = false
    }
    if(this.isFirstActive) {
      this.isFirstActive = false
    }

    this.setBizProperty({
      event: 'setBizProperty',
      bizProperty: this.institutionsGtmInfo
    })
  }

  reLoadInvoices() {
    this.clearTransferredInvoices()
    this.loadInvoices()
  }

  loadInvoices() {
    this.loading = true
    const {id: clientId} = this.selectedClient || {}
    return this.getTransferredInvoices({order: this.selectedOrder, client: clientId})
      .then(() => {
        this.loading = false
        if(this.isRequiredReload) {
          this.$emit('remove-required-reload-list', this.tabName)
        }
        this.listView.fillContents()
      })
      .catch((error) => {
        this.isError = true
        this.updateError({
          id: 'get-transferred-invoices',
          message: this.ts('error.get-invoice'),
        })
        this.loading = false
        throw error
      })
  }

  loadClients(name) {
    this.loadingClients = true
    this.getClients({name})
      .then(() => {this.loadingClients = false})
      .catch((error) => {
        this.loadingClients = false
        this.updateError({
          id: 'get-clients',
          message: this.ts('error.get-clients'),
        })
        throw error
      })
  }

  onClick(invoiceId) {
    this.$router
      .push({
        name: 'received-invoice-detail',
        params: {invoiceId},
      })
      .catch((err) => err)
  }

  onSelectOrder(value) {
    this.selectedOrder = value
  }

  onSelectClient(value) {
    this.selectedClient = value
  }

  onScroll() {
    if(this.isError || this.transferredNextOffset === null) return
    this.loadInvoices()
  }

  onClickClientFilter() {
    if(this.selectedClient) {
      this.selectedClient = null
    } else {
      this.openClientFilter = true
    }
  }

  onCompletedWorkflows() {
    this.reLoadInvoices()
    this.$emit('set-required-reload-list', this.tabName)
  }

  onClickInvoiceMore(invoice: Invoice) {
    const {status, isForcedPayment} = invoice
    if(status === 'completed' && !isForcedPayment) {
      this.openDialog = true
    } else {
      this.selectedInvoiceId = invoice.id
      this.selectedInvoiceStatus = invoice.status
      this.openChangeStatus = true
    }
  }

  onChangeStatus(status) {
    this.changingStatus = true
    this.updateInvoiceStatus({id: this.selectedInvoiceId, status})
      .then(() => {
        this.reLoadInvoices()
        this.$emit('set-required-reload-list', this.tabName)
      })
      .catch((error) => {
        this.updateError({
          id: 'update-invoice-status',
          message: this.ts('error.update-invoice-status'),
        })
        throw error
      })
      .finally(() => {
        this.changingStatus = false
        this.selectedInvoiceId = ''
        this.selectedInvoiceStatus = ''
      })
  }
}
